/**
 * Small bounded ring buffer of recent client errors, attached to the bug
 * reporter so a report carries the console context that led up to it. Installed
 * once at app startup for every user (harmless + tiny); only READ when an early
 * adopter submits a bug report.
 */
const MAX_ENTRIES = 25;
const buffer = [];
let installed = false;

function push(text) {
    try {
        buffer.push(`[${new Date().toISOString()}] ${String(text).slice(0, 500)}`);
        while (buffer.length > MAX_ENTRIES) {
            buffer.shift();
        }
    } catch (e) {
        // never let error capture throw
    }
}

function installErrorBuffer() {
    if (installed || typeof window === 'undefined') {
        return;
    }
    installed = true;

    const originalError = (typeof console !== 'undefined' && console.error) ? console.error.bind(console) : null;
    if (originalError) {
        console.error = function(...args) {
            push('console.error: ' + args.map(a => (a && a.stack) || String(a)).join(' '));
            originalError(...args);
        };
    }

    window.addEventListener('error', (e) => {
        const where = (e && e.filename) ? ` @ ${e.filename}:${e.lineno}` : '';
        push('window.error: ' + ((e && e.message) || 'unknown') + where);
    });

    window.addEventListener('unhandledrejection', (e) => {
        const reason = (e && e.reason && (e.reason.stack || e.reason.message)) || String(e && e.reason);
        push('unhandledrejection: ' + reason);
    });
}

function getRecentErrors() {
    return buffer.slice();
}

export { installErrorBuffer, getRecentErrors };


// WEBPACK FOOTER //
// ./src/lib/errorBuffer.js